module.exports = __webpack_public_path__ + "static/media/excel-doc.e461bcdd.svg";